export default "__VITE_ASSET__51e0199e__"